// extracted by mini-css-extract-plugin
module.exports = {"link-blue":"#325bbd","heading":"NotFound-module__heading___A_zMC","inner":"NotFound-module__inner___2s1e_","link":"NotFound-module__link___2FsWf"};